import { render, staticRenderFns } from "./BannerLayout.vue?vue&type=template&id=31de65e9&scoped=true"
import script from "./BannerLayout.vue?vue&type=script&lang=js"
export * from "./BannerLayout.vue?vue&type=script&lang=js"
import style0 from "./BannerLayout.vue?vue&type=style&index=0&id=31de65e9&prod&lang=css"
import style1 from "./BannerLayout.vue?vue&type=style&index=1&id=31de65e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de65e9",
  null
  
)

export default component.exports